import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { i18next } from '@yola/ws-sdk';
import { designSystem } from '@yola/ws-ui';
import {
  CONTAINER_WIDTH_PRESETS,
  CONTAINER_WIDTH_MIN_CUSTOM_PX,
  CONTAINER_WIDTH_MAX_CUSTOM_PX,
} from '../constants/container-width';
import BlockSettingsSlider from './block-settings-slider';

const { Box, RadioButtonGroup, RadioButton, TabNonSwipeableArea } = designSystem;

const getPresetOptions = () => [
  { preset: CONTAINER_WIDTH_PRESETS.NARROW, label: i18next.t('Narrow') },
  { preset: CONTAINER_WIDTH_PRESETS.WIDE, label: i18next.t('Wide') },
  { preset: CONTAINER_WIDTH_PRESETS.FILL, label: i18next.t('Fill') },
  { preset: CONTAINER_WIDTH_PRESETS.CUSTOM, label: i18next.t('Custom') },
];

function ContainerWidthOption({
  value,
  customValue: initialCustomValue = null,
  onClick,
  onChange,
  onAfterChange,
}) {
  const [customValue, setCustomValue] = useState(null);

  useEffect(() => {
    setCustomValue(initialCustomValue);
  }, [initialCustomValue]);

  const handleSliderChange = (val) => {
    setCustomValue(val);
    onChange(val);
  };

  return (
    <React.Fragment>
      {/* TODO: refactor to dropdown with ActionListItems */}
      <RadioButtonGroup name="container-width" selectedValue={value} onChange={onClick}>
        {getPresetOptions().map(({ preset, label }) => (
          <RadioButton
            key={preset}
            id={`container-width-${preset}`}
            value={preset}
            label={label}
            isLabelBold
          />
        ))}
      </RadioButtonGroup>

      {value === CONTAINER_WIDTH_PRESETS.CUSTOM && (
        <Box marginTop="spacing-2-xs">
          <TabNonSwipeableArea>
            <BlockSettingsSlider
              itemId="container_width"
              min={CONTAINER_WIDTH_MIN_CUSTOM_PX}
              max={CONTAINER_WIDTH_MAX_CUSTOM_PX}
              step={100}
              value={customValue}
              onChange={handleSliderChange}
              onAfterChange={onAfterChange}
            />
          </TabNonSwipeableArea>
        </Box>
      )}
    </React.Fragment>
  );
}

ContainerWidthOption.propTypes = {
  value: PropTypes.string.isRequired,
  customValue: PropTypes.number,
  onClick: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onAfterChange: PropTypes.func.isRequired,
};

export default ContainerWidthOption;
